<template>
  <div class="list__action__item--content">
    <div class="flex-row flex__between">
      <el-tooltip
        :content="`${receiveAgency.name} (${receiveAgency.code} - ${receiveAgency.mail})`"
        placement="top"
      >
        <p class="name margin-0">
          {{ receiveAgency ? receiveAgency.name : "-" }}
        </p>
      </el-tooltip>
      <div class="time font-size__small">
        <i class="fal fa-clock"></i>
        {{ updateTime | convertToLabelFilter }}
      </div>
    </div>
    <div>
      <p
        :class="['action-type flex-row flex__left inline-flex', 'color__blue']"
      >
        <i :class="['font-size__small', 'fal fa-check-circle']"></i>
        <span class="font-size__small no_wrap">
          &nbsp;{{ "Đã nhận văn bản" }}
        </span>
      </p>

    </div>
  </div>
</template>

<script>
  import convertToLabelFilter from "../../filters/convertToLabelFilter";
  import PopoverWord2 from "../common/popover-word-2";

  export default {
    name: "history-danhan-tltvb",
    components: {PopoverWord2},
    props: ["action"],
    filters: {
      convertToLabelFilter
    },
    data() {
      return {
        words: [],
        receiveAgency: [],
        updateTime: null,
      };
    },
    created() {
      this.action && this.initData();
    },
    methods: {
      initData() {
        let dataJson = this.action.dataJson;
        this.receiveAgency = dataJson.receiveAgency;
        this.updateTime = dataJson.updateTime;
        let sentence = this.receiveAgency.name;
        this.words = sentence.split(" ");
      },
    }
  };
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/views/doc-in/history-danhan-tltvb.vue